import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import styled from 'styled-components';
import { device } from './media_queries';

const GCIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-top: 5px;
  margin-left: -4px;
  position: absolute;
  float: left;
  align-self: flex-start;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

function getModalStyle() {
  const top =  60;
  const left = 65;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 550,
    height: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let arreglo = props.data.data;
  let register = arreglo ? arreglo.find( element => element.name === props.data.type) : null


  return (
    <div style={{width: "15px", height: "15px", position: "absolute", float: "left", alignSelf: "flex-start"}}>
      <GCIcon onClick={handleOpen} src="https://res.cloudinary.com/dojodevs/image/upload/v1579572033/smartia/%C3%ADconos/info_logoGrisClaro_a_ry3q0s.png" alt="info icon" style={{cursor: 'pointer'}}/>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={classes.paper}>
          <h2 id="simple-modal-title">{ props.data.title ? props.data.title : "Cargando" }</h2>
          <p id="simple-modal-description">
            { props.data.subtitle ? props.data.subtitle : "Cargando" }
          </p>
          <p>
          { 
            props.data.description ? props.data.description : "" 
          }
          </p>
        </div>
      </Modal>
    </div>
  );
}
